import { render, staticRenderFns } from "./ViewTransactionMonitoringPortalByRoute.vue?vue&type=template&id=31e70495&scoped=true&"
import script from "./ViewTransactionMonitoringPortalByRoute.vue?vue&type=script&lang=js&"
export * from "./ViewTransactionMonitoringPortalByRoute.vue?vue&type=script&lang=js&"
import style0 from "./ViewTransactionMonitoringPortalByRoute.vue?vue&type=style&index=0&id=31e70495&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e70495",
  null
  
)

export default component.exports